module.exports = __webpack_public_path__ + "static/hand-7c2cf067be130bdc87a8a749a568ffe5.png";